import { createApp } from 'vue'
import { Quasar } from 'quasar'
import App from './components/layout/App.vue'
import quasarUserOptions from './quasar-user-options'
import '../styles/hior/hior.scss'
import commonComponents from './components'
import pageComponents from './pages'
import VueSkipTo from '@vue-a11y/skip-to'
import '@vue-a11y/skip-to/dist/style.css'

import {
    dialogMixin,
    formMixin,
    momentMixin,
    navMixin,
    propsMixin,
    routeMixin,
    sanitizeMixin,
    userMixin,
} from './mixins'
import { createPinia } from 'pinia';

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}
const pinia = createPinia()

const app = createApp(App)
    .use(pinia)
    .mixin(dialogMixin)
    .mixin(formMixin)
    .mixin(propsMixin)
    .mixin(routeMixin)
    .mixin(momentMixin)
    .mixin(userMixin)
    .mixin(sanitizeMixin)
    .mixin(navMixin)
    .use(VueSkipTo)
    .use(Quasar, quasarUserOptions)

Object.keys(commonComponents).forEach((name) => {
    app.component(name, commonComponents[name])
})
Object.keys(pageComponents).forEach((name) => {
    app.component(name, pageComponents[name])
})

app.mount('#app')
